export default "__VITE_ASSET__CIA2i9af__"